import { Button, Form, Input } from "antd"
import { User } from "@types";
import { useEffect } from "react";
import { useAddParticipant, useEditParticipant } from "@hooks";
import { PlusCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useQueryClient } from "@tanstack/react-query";

interface Props {
    participant?: User;
    examTermId: string;
}

export const ParticipantForm = ({participant, examTermId}: Props) => {

    const [form] = Form.useForm();
    const {t} = useTranslation();
    const addParticipant = useAddParticipant();
    const editParticipant = useEditParticipant();
    const queryClient = useQueryClient();

    useEffect(() => {
        if (participant) {
            form.setFieldsValue(participant);
        }
    }, [form, participant])

    const onFinish = (values: any) => {
        if (participant) {
            editParticipant.mutate({
                examTermId,
                participant: {
                    ...participant,
                    ...values
                }
            }, {
                onSuccess() {
                    queryClient.invalidateQueries({ queryKey: ["examPeriods"] });
                }
            });
        } else {
            addParticipant.mutate(values, {
                onSuccess() {
                    form.resetFields();
                }
            });
        }
    }

    return (
                <Form form={form} layout="vertical" requiredMark onFinish={onFinish}>
                         <Form.Item
                                name={["firstName"]}
                                label={t("pages.examPeriods.applicantsTab.userName")}
                                rules={[{ required: true }]}
                            >
                <Input />
              </Form.Item>
                            <Form.Item
                                name={["lastName"]}
                                label={t("pages.examPeriods.applicantsTab.lastName")}
                                rules={[{ required: true }]}
                            >
                <Input />
              </Form.Item>
                            <Form.Item
                                name={["email"]}
                                label={t("pages.examPeriods.applicantsTab.email")}
                                rules={[{ required: true }, { type: "email" }]}
                                normalize={(value) => value?.trim()}
                            >
                <Input />
              </Form.Item>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Button type="primary" htmlType="submit" loading={participant ? editParticipant.isPending : addParticipant.isPending} icon={<PlusCircle />}>
                {t("pages.examPeriods.applicantsTab.addToList")}
                </Button>
              </div>
        </Form>
    )
}